import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { setParentalControl } from 'src/app/shared/constants';
import { environment } from 'src/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ParentalControlService {

  setLimitAge = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient, private storageService: StorageService) { }

  setParentalControl(data) {
    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    data['profile_id'] = profileId || uId;
    const accountUrl = environment.apiEndpoint + environment.version + setParentalControl;
    return this.http.post(accountUrl, data).pipe(
      map(
        (response: any) => {
          if (response.status_code === 200) {
            return response;
          }
        }
        , (error: HttpErrorResponse) => {
          return error;
        }
      )
    );
  }

}
